import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CosmeticPresets, Filter, Presets, PreviewCustomRule } from '../models/filter-models';
import { FilterService } from '../services/filter.service';
import { TooltipWrapperComponent } from '../common/tooltip-wrapper/tooltip-wrapper.component';
import { CosmeticPresetsService } from '../services/cosmetic-presets.service';
import { RulePreviewComponent } from '../common/rule-preview/rule-preview.component';
import { BaseComponent } from '../common/base.component';
import { PresetsService } from '../services/presets.service';
import { PresetPreviewService } from '../services/preset-preview.service';
import { imgPrefix } from '../../game';

@Component({
  selector: 'app-progress-presets',
  imports: [TooltipWrapperComponent, RulePreviewComponent],
  templateUrl: './progress-presets.component.html',
  styleUrls: ['./progress-presets.component.scss', '../common/preset-preview-shared.scss']
})
export class ProgressPresetsComponent extends BaseComponent implements OnChanges {
  @Input({ required: true }) filter!: Filter;

  changeVisualStyle = false;
  prefix = imgPrefix
  exampleLabelRuleStyled?: PreviewCustomRule;
  exampleLabelRuleUnstyled?: PreviewCustomRule;

  constructor(private filterService: FilterService, private cosmeticPresetsService: CosmeticPresetsService, public presetsService: PresetsService, private presetPreviewService: PresetPreviewService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filter']) {
      const cosmeticPresets = this.filter.cosmeticPresets;
      this.changeVisualStyle = cosmeticPresets.labelColor !== 'default' && cosmeticPresets.labelSize !== 'default';

      let rules = this.cosmeticPresetsService.generateDefaultRules(false, { labelColor: 'accentTiered', labelSize: 'larger' } as CosmeticPresets);
      this.exampleLabelRuleStyled = new PreviewCustomRule(rules[0]);
      this.exampleLabelRuleStyled.exampleName = 'Divine Orb';

      rules = this.cosmeticPresetsService.generateDefaultRules(false, { labelColor: 'default', labelSize: 'default' } as CosmeticPresets);
      this.exampleLabelRuleUnstyled = new PreviewCustomRule(rules[0]);
      this.exampleLabelRuleUnstyled.exampleName = 'Divine Orb';
    }
  }

  setPreset(preset: Presets) {
    this.presetPreviewService.initiateProgressPresetChange(preset);
  }

  previewProgressPreset(preset: Presets) {
    this.presetPreviewService.previewProgressPresetChange(preset);
  }

  toggleSsf() {
    this.presetsService.toggleSsf();
  }

  toggleChangeVisualStyle() {
    this.changeVisualStyle = !this.changeVisualStyle;
    if (this.changeVisualStyle) {
      this.filter.cosmeticPresets.labelColor = 'accentTiered';
      this.filter.cosmeticPresets.labelSize = 'larger';
    } else {
      this.filter.cosmeticPresets.labelColor = 'default';
      this.filter.cosmeticPresets.labelSize = 'default';
    }
    this.cosmeticPresetsService.applyPreset(this.filter);
    this.filterService.updateFilter();
  }

  updateFilter() {
    this.filterService.updateFilter();
  }
}
